module.exports = __webpack_public_path__ + "img/bottom_circle.4e50268.4e502687.png";